export type TAuthError = string | { message?: string };

export const getAuthError = (error: TAuthError) => {
  if (typeof error === 'string') return error;
  else {
    return error.message;
  }
};
